import React from "react";
import Login from "../pages/auth/Login";
import Add_info from "../pages/auth/Add_info";
import Join_group from "../pages/auth/Join_group";
import { Route, Routes } from "react-router";
import Home from "../pages/landingpage/Home";
import Otp from "../pages/auth/Otp";
import Signup from "../pages/auth/registration/Signup";
import Sidebar from "../Components/sidebar/Sidebar";
import Overview from "../pages/dashboard/Overview/Overview";
import OverwiewDetail from "../pages/dashboard/Overview/OverwiewDetail";
import Groups from "../pages/dashboard/Groups/Groups";
import Profile from "../pages/dashboard/Profile/Profile";
import Message from "../pages/dashboard/Message/Message";
import GroupsDetail from "../pages/dashboard/Groups/GroupsDetail";
import About from "../pages/faqs/About";
import Terms from "../pages/faqs/Terms";
import Privacy from "../pages/faqs/Privacy";
import NotFound from "../pages/404/404";
import CreateGroup from "../pages/dashboard/Groups/createGroup/CreateGroup";
import EditGroup from "../pages/dashboard/Groups/editGroup/EditGroup";
import CreateChildrenGroup from "../pages/dashboard/Groups/childrenGroups/CreateChildrenGroup";
import EditChildrenGroup from "../pages/dashboard/Groups/childrenGroups/EditChildrenGroup";
import CreateFeeds from "../pages/dashboard/feeds/CreateFeeds";
import EditFeeds from "../pages/dashboard/feeds/EditFeeds";
import FeedDetail from "../pages/dashboard/feeds/FeedDetail";
import Categories from "../pages/dashboard/Categories/Categories";
import CategoriesGroupsList from "../pages/dashboard/Categories/CategoriesGroupsList";
import GroupsDetail_two from "../pages/dashboard/Groups/GroupsDetail_two";
import ConnectMeet from "../pages/dashboard/Profile/section/ConnectMeet";
import GoogleMeet from "../pages/dashboard/googleMeet/GoogleMeet";

import LiveDetail from "../pages/dashboard/Overview/LiveDetail";
import GoLive from "../pages/dashboard/Overview/GoLive";
import Send_Msg_Req from "../pages/dashboard/Groups/groupRequestDrawer/Send_Msg_Req";
import Remove_Member from "../pages/dashboard/Groups/groupRequestDrawer/Remove_Member";
import CategoryDetails from "../pages/dashboard/Categories/CategoryDetails";
import AccountDeleteSetting from "../pages/faqs/AccountDeleteSetting";
import StripeConnectAccount from "../pages/stripeConnectAccount";
import DeleteAccount from "../pages/deleteaccount/DeleteAccount";
import NewHome from "../pages/landingpage/NewHome";

const Routing = () => {
  return (
    <>
      <Routes>
        <Route path="/404" element={<NotFound />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        {/* <Route path="/" element={<Home />} /> */}
        <Route path="/" element={<NewHome />} />
        <Route path="/successful" element={<StripeConnectAccount />} />
        <Route path="/login" element={<Login />} />
        <Route path="/otp" element={<Otp />} />
        <Route path="/registration" element={<Signup />} />
        <Route path="/addinfo" element={<Add_info />} />
        <Route path="/joingroup" element={<Join_group />} />
        <Route path="/calendar-event" element={<GoogleMeet />} />
        <Route path="/about" element={<About />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/account-setting" element={<AccountDeleteSetting />} />

        <Route path="/dashboard" element={<Sidebar />}>
          <Route path="/dashboard/overview" element={<Overview />} />
          <Route
            path="/dashboard/overview/detail/:id"
            element={<OverwiewDetail />}
          />
          <Route
            path="/dashboard/overview/live-details"
            element={<LiveDetail />}
          />

          <Route path="/dashboard/overview/go-live" element={<GoLive />} />

          <Route path="/dashboard/group" element={<Groups />} />
          <Route
            path="/dashboard/group/groupRequestDrawer/remove_member"
            element={<Remove_Member />}
          />

          <Route
            path="/dashboard/group/groupRequestDrawer/Send_Msg_Req/:memberId"
            element={<Send_Msg_Req />}
          />
          <Route
            path="/dashboard/group/create-group"
            element={<CreateGroup />}
          />
          <Route
            path="/dashboard/group/create-feed/:groupId"
            element={<CreateFeeds />}
          />
          <Route
            path="/dashboard/group/edit-group/:groupId"
            element={<EditGroup />}
          />
          <Route
            path="/dashboard/feed/edit-feed/:feedId"
            element={<EditFeeds />}
          />
          <Route
            path="/dashboard/group/detail/:groupId"
            element={<GroupsDetail />}
          />
          <Route
            path="/dashboard/group/feed/detail/:groupId/:feedId"
            element={<FeedDetail />}
          />
          <Route
            path="/dashboard/group/create-level-group/:parentGroupId/:adminId?"
            element={<CreateChildrenGroup />}
          />
          <Route
            path="/dashboard/group/edit-level-group/:parentGroupId"
            element={<EditChildrenGroup />}
          />

          <Route path="/dashboard/message/group/:chatId?/:tab?" element={<Message chatType='GROUP' />} />
          <Route path="/dashboard/message/member/:chatId?/:tab?" element={<Message chatType='MEMBER' />} />

          <Route path="/dashboard/profile" element={<Profile />} />

          <Route path="/dashboard/category" element={<Categories />} />
          <Route
            path="/dashboard/category/group-list"
            element={<CategoriesGroupsList />}
          />
          <Route
            path="/dashboard/category/groups/:groupId"
            element={<CategoryDetails />}
          />
        </Route>
      </Routes>
    </>
  );
};

export default Routing;
